import axios from "axios";
import { Component } from "react";
import { setHeaderAuth } from "../utils";

class ApiPermissions extends Component {
    static get = async (page_code) => {
        await setHeaderAuth();
        const result = await axios({
            url: "permissions",
            method: "get",
            headers: {
                'page_code': page_code
            }
        });
        return result;
    };
}

export default ApiPermissions;
